/**
 * Created by akirilyuk on 2/9/18.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/createCaseSubViews/sdkView.tmpl"),
        AttachmentsView = require("connection-views/ticketTab/extendedList/TicketAttachmentView"),
        AttachmentUpload = require("connection-views/ticketTab/extendedList/AttachmentUploadInput"),
        HtmlSanitizerUtils = require("HtmlSanitizerUtils"),
        InputField = require("ui/input-field/InputField"),
        Button = require("ui/button/Button"),
        SDKView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        SDKView = Marionette.ItemView.extend({
            template: template,
            className: 'create-case-sub-view-sdk',
            ui: {
                logsAttachmentsRegion: ".logs-attachments-region .data-container",
                logsAttachmentsUpload: ".logs-attachments-region .attachments-upload",
                screenAttachmentsRegion: ".screen-videos-attachments-region .data-container",
                screenAttachmentsUpload: ".screen-videos-attachments-region .attachments-upload",
                codeAttachmentsRegion: ".code-attachments-region .data-container",
                codeAttachmentsUpload: ".code-attachments-region .attachments-upload",
                deviceVersion: ".device-version-container .input-container",
                sdkVersion: ".sdk-version-container .input-container",
                osVersion: ".os-version-container .input-container"
            },
            // the buttons are only for PoC the solution design
            uiComponents: {
                logsAttachmentsRegion: {
                    type: AttachmentsView,
                    options: {
                        el: "view.ui.logsAttachmentsRegion",
                        collection: "view._getAttachmentsCollection",
                        type: "logs",
                        doFilter: true
                    }
                },
                logsAttachmentsUpload: {
                    type: AttachmentUpload,
                    options: {
                        el: "view.ui.logsAttachmentsUpload",
                        view: "view",
                        collection: "view._getAttachmentsCollection",
                        type: "logs"
                    }
                },
                screenAttachmentsRegion: {
                    type: AttachmentsView,
                    options: {
                        el: "view.ui.screenAttachmentsRegion",
                        collection: "view._getAttachmentsCollection",
                        type: "screen",
                        doFilter: true
                    }
                },
                screenAttachmentsUpload: {
                    type: AttachmentUpload,
                    options: {
                        el: "view.ui.screenAttachmentsUpload",
                        view: "view",
                        collection: "view._getAttachmentsCollection",
                        type: "screen"
                    }
                },
                codeAttachmentsRegion: {
                    type: AttachmentsView,
                    options: {
                        el: "view.ui.codeAttachmentsRegion",
                        collection: "view._getAttachmentsCollection",
                        type: "code",
                        doFilter: true
                    }
                },
                codeAttachmentsUpload: {
                    type: AttachmentUpload,
                    options: {
                        el: "view.ui.codeAttachmentsUpload",
                        view: "view",
                        collection: "view._getAttachmentsCollection",
                        type: "code"
                    }
                },
                deviceVersion: {
                    type: InputField,
                    options: {
                        el: "view.ui.deviceVersion",
                        permutation: InputField.Permutation.B
                    }
                },
                sdkVersion: {
                    type: InputField,
                    options: {
                        el: "view.ui.sdkVersion",
                        permutation: InputField.Permutation.B
                    }
                },
                osVersion: {
                    type: InputField,
                    options: {
                        el: "view.ui.osVersion",
                        permutation: InputField.Permutation.B
                    }
                }
            },

            initialize: function (options) {
                this.attachmentsCollection = options.attachmentsCollection;
                this.storageModel = options.storageModel;

            },

            onRender: function () {
                this._initValuesFromStorage();
                this._bindEvents();
                this._initMandatoryFields();
            },

            getTextFieldsValuesInConcatString: function () {
                var textString = "";
                this.mandatoryFields.forEach(function (field) {
                    textString = textString.concat(this._getLabelAndTextFromPropertyContainer(field)) + "\n";
                },this);
                return textString;
            },

            isValid: function () {
                return this._validateAndDisplayError(this.mandatoryFields, LE.translator.translate("LEConnection.cases.createView.error.MandatoryField"));
            },

            getViewName: function () {
                return LE.translator.translate("LEConnection.cases.createView.sdkView.name");
            },

            _initMandatoryFields: function () {
                this.mandatoryFields = [];
                this.mandatoryFields.push(this.uiComponents.osVersion);
                this.mandatoryFields.push(this.uiComponents.sdkVersion);
                this.mandatoryFields.push(this.uiComponents.deviceVersion);
            },

            _validateAndDisplayError: function (fields, errorMsg) {
                var valid = true;
                var that = this;
                _.each(fields, function (field) {
                    var fieldValue = that._getSanitizedValue(field);
                    if (_.isNull(fieldValue) || fieldValue.length === 0) {
                        valid = false;
                        if (_.isFunction(field.setError)) {
                            field.setError(true, errorMsg);
                        }
                    }
                });
                return valid;
            },

            _getLabelAndTextFromPropertyContainer: function (field) {
                var text = "";
                var labelNode = (field && field.el && field.el.parentElement && field.el.parentElement &&
                field.el.parentElement.children && field.el.parentElement.children[0]) ? field.el.parentElement.children[0] : {};
                text += labelNode.innerText;
                text += "\n";
                text += this._getSanitizedValue(field);
                return text;
            },

            _bindEvents: function () {
                this.listenTo(this.uiComponents.deviceVersion, InputField.TRIGGERING.ONBLUR, this._onDeviceVersionBlur);
                this.listenTo(this.uiComponents.sdkVersion, InputField.TRIGGERING.ONBLUR, this._onSdkVersionBlur);
                this.listenTo(this.uiComponents.osVersion, InputField.TRIGGERING.ONBLUR, this._onOsVersionBlur);
            },

            _initValuesFromStorage: function () {
                this._initDeviceVersion(this.storageModel.getDeviceVersion());
                this._initSdkVersion(this.storageModel.getSdkVersion());
                this._initOsVersion(this.storageModel.getOsVersion());
            },

            _getAttachmentsCollection: function () {
                return this.attachmentsCollection;
            },

            _initDeviceVersion: function (value) {
                if (value && value.length > 0 && this.getIsRendered()) {
                    this.uiComponents.deviceVersion.setValue(value);
                }
            },

            _initSdkVersion: function (value) {
                if (value && value.length > 0 && this.getIsRendered()) {
                    this.uiComponents.sdkVersion.setValue(value);
                }
            },

            _initOsVersion: function (value) {
                if (value && value.length > 0 && this.getIsRendered()) {
                    this.uiComponents.osVersion.setValue(value);
                }
            },

            _onDeviceVersionBlur: function () {
                var text = this._getSanitizedValue(this.uiComponents.deviceVersion);
                if (text && text.length > 0) {
                    this.storageModel.setDeviceVersion(text);
                }
            },

            _onSdkVersionBlur: function () {
                var text = this._getSanitizedValue(this.uiComponents.sdkVersion);
                if (text && text.length > 0) {
                    this.storageModel.setSdkVersion(text);
                }
            },

            _onOsVersionBlur: function () {
                var text = this._getSanitizedValue(this.uiComponents.osVersion);
                if (text && text.length > 0) {
                    this.storageModel.setOsVersion(text);
                }
            },

            _getSanitizedValue: function (field) {
                return HtmlSanitizerUtils.sanitizeHtml(field.getValue()).cleanText;
            }


        });
    });
    return SDKView;
});
